// en-US Intl renders some currencies as letter codes (RUB instead of ₽),
// so the ones we actually sell in are mapped explicitly.
const SYMBOLS: Record<string, string> = {
  usd: "$",
  eur: "€",
  rub: "₽",
};

export const getCurrencySymbol = (currency: string, locale = "en-US") =>
  SYMBOLS[currency.toLowerCase()] ??
  (0)
    .toLocaleString(locale, {
      style: "currency",
      currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })
    .replace(/\d/g, "")
    .trim();
